<template>
  <button type="button" class="tag" @click="handleClick">
    <tag-icon iconClass="icon" />
    {{ tag }}
  </button>
</template>

<style scoped>
  .tag {
    display: flex;
    align-items: center;
    color: var(--primary-color);
    background-color: #fff;
    margin: 0 8px 8px 0;
    text-decoration: none;
    text-align: center;
    border: none;
    cursor:pointer;
  }
  .tag:hover {
    color: var(--secondary-color);
  }
  .icon {
    margin-right: 4px;
  }
</style>

<script>
import { mapActions } from 'vuex';
import TagIcon from '@/components/icons/TagIcon.vue';

export default {
  name: 'tag',
  props: {
    tag: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.changeTextFilter(this.tag);
    },
    ...mapActions({
      changeTextFilter: 'changeTextFilter',
    }),
  },
  components: {
    TagIcon,
  },
};
</script>
